import { applyMiddleware, CombinedState, combineReducers, compose, createStore as _createStore } from 'redux';
import thunk from 'redux-thunk';

import { IApplicationContext } from '../../types/applicationContext';
import { IApplicationState, TReduxActions, IReduxStore, TThunkDispatch } from '../../types/redux';
import { createSimpleReducer } from './createSimpleReducer';
import { BUILDER_CARD_DEFAULT } from '../../constants/builder';
import { USER_DEFAULT } from '../../constants/user';
import { LAYOUT_DEFAULT } from '../../constants/layout';

interface IThunkExt {
  dispatch: TThunkDispatch;
}

let storeReminder: IReduxStore;

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 */
export function createReduxStore(context: IApplicationContext, initialState: IApplicationState, debugEnabled: boolean) {
  const reducers = combineReducers<IApplicationState, TReduxActions>({
    builderCard: createSimpleReducer(BUILDER_CARD_DEFAULT),
    user: createSimpleReducer(USER_DEFAULT),
    layout: createSimpleReducer(LAYOUT_DEFAULT),
    location: createSimpleReducer(null),
    breadcrumbs: createSimpleReducer(initialState.breadcrumbs),
    showCallbackButton: createSimpleReducer(true),
  });

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers(applyMiddleware(thunk.withExtraArgument(context)));

  const createStore = (): IReduxStore =>
    _createStore<CombinedState<IApplicationState>, TReduxActions, IThunkExt, {}>(
      reducers,
      initialState,
      storeEnchancers,
    );

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
